import { GetLocalStorageValue } from '../../../../_config/utils/get-local-storage-value.util';
import { ENV_COUNTRY } from '../../../../hooks/enviroment';

const user = GetLocalStorageValue('userInfo');

export const checkRol = (pharmacy) => {
    if (ENV_COUNTRY === 'CLNARMA' || ENV_COUNTRY === 'CLANICX' || ENV_COUNTRY === 'CLGREEN') return '/v2/tracking/list?status=all&page=1';
    if (user?.pharmacy) return '/v2/tracking/list?status=all&page=1';
    return `/v2/admin-tracking/list?status=all&page=1`;
};
